import { Component } from '@angular/core';


@Component({
    selector: 'soft-create-page',
    imports: [],
    templateUrl: './create-page.component.html',
    styleUrl: './create-page.component.css'
})
export class CreatePageComponent {}
